import React from 'react';
import PropTypes from 'prop-types';

const Thumbnail = props => (
  <div className={`thumbnail pic-${props.index}`} key={props.index}>
    <span
      onClick={() => props.selectedImageIndexChanged(props.index)}
      role="button"
      tabIndex={-1}
      className={`thumbnail-img ${props.image.id === props.selectedImageIndex ? 'selected' : ''}`}
    >
      <img src={props.image.thumbnailURL} alt="" />
    </span>
  </div>
);

Thumbnail.propTypes = {
  image: PropTypes.shape({
    thumbnailURL: PropTypes.string.isRequired,
    largeImageURL: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  selectedImageIndexChanged: PropTypes.func.isRequired,
  selectedImageIndex: PropTypes.number.isRequired,
};

export default Thumbnail;



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/ImageCarousel/Thumbnail.js